import DotLegalFullScreenSpinner from "../../common/components/dotLegalFullScreenSpinner/DotLegalFullScreenSpinner";
import CustomerDialog from "../customerDialog/CustomerDialog";
import { useCustomerRedirectWrapper } from "./CustomerRedirectWrapper.hooks";

export interface CustomerRedirectWrapperProps {
    children: JSX.Element;
}

function CustomerRedirectWrapper(props: CustomerRedirectWrapperProps) {
    const { isLoading } = useCustomerRedirectWrapper();

    return isLoading ? <DotLegalFullScreenSpinner /> : props.children;
}

export default CustomerRedirectWrapper;
